import { THANK_YOU_TYPES } from '@/utils/constants';

const coach = () => import('./thanksCoach');
const fnol = () => import('./FNOLRecieved');

export default {
  [THANK_YOU_TYPES.COACH_SUBMIT]: coach,
  [THANK_YOU_TYPES.FNOL_SUBMIT]: fnol,
};
